import { Box, Flex, CircularProgress, CircularProgressLabel } from '@chakra-ui/react';
import {resetUploadProgressMetric} from '../../digital-sales-room/actions/dsr-actions';
import {useEffect, useState} from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

function FileUploadProgress({ percentProcessed, showLoader, resetUploadProgressMetric }) {
  const [showFinalizing, setShowFinalizing] = useState(false)
  const [blinkCount, setBlinkCount] = useState(0)
  
  useEffect(() => {
    if (percentProcessed === 100) {
      resetUploadProgressMetric();
      setShowFinalizing(true);
      setBlinkCount((prevCount) => prevCount + 1);
    }
  }, [percentProcessed, resetUploadProgressMetric]);

  if (showLoader) {
    if (showFinalizing) {
      return (
        <Flex direction='column' align='center' justify='center' bg='white' className="fade-in">
        <Box className="brand-animation" />
        <Box mt='1em' fontSize='0.875em' color='brandDark.500'>Finalizing...</Box>
      </Flex>
      )
    } else {
      return (
        <Flex direction='column' align='center' justify='center' bg='white'>
          <CircularProgress isIndeterminate color={showFinalizing ? "brandPink.500":'brand.500'} size='3em' thickness='4px' transition="color 0.2s ease-in-out">
            <CircularProgressLabel fontSize='0.5em' color='gray.700'>{!showFinalizing && `${percentProcessed ? percentProcessed : 0}%`}</CircularProgressLabel>
          </CircularProgress>
          <Box key={`upload-progress-${blinkCount}`} mt='1em' fontSize='0.875em' color='brandDark.500'>{showFinalizing ? "Finalizing..." :'Working on it ...'}</Box>
        </Flex>
      );
    }
   
  } else {
    return null;
  }
  
};

const mapStateToProps = (state, ownProps) => {
  return {
    percentProcessed: ownProps.subWidgetId
      ? state.fileUploadPercentProcessed.fileUploadProgress[ownProps.subWidgetId] || 0
      : state.fileUploadPercentProcessed.fileUploadProgress.global || 0,
      // TODO: Review the need for global if postId is passed as a variable
  };
};
const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
      {
        resetUploadProgressMetric
      },
      dispatch,
    )


export default connect(mapStateToProps, mapDispatchToProps)(FileUploadProgress);
